import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.jsx';
import SubscribeBanner from '../SubscribeBanner.jsx';
import TopNav from './TopNav.jsx';
import SubscriberSubNav from './SubscriberSubNav.jsx';

export default function AppLayout() {
  const { pathname } = useLocation();
  const { isAuthenticated, loading } = useAuth();
  const isSubscriberArea =
    pathname === '/' ||
    pathname === '/today' ||
    pathname.startsWith('/archive') ||
    pathname.startsWith('/referrals');
  const showSubscribeBanner =
    isSubscriberArea &&
    pathname !== '/' &&
    !loading &&
    !isAuthenticated;

  return (
    <div className="min-h-full flex flex-col">
      <header className="hxd-site-header">
        <TopNav />
        {isSubscriberArea && <SubscriberSubNav />}
      </header>
      {showSubscribeBanner && <SubscribeBanner />}
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t border-hxd-border bg-white">
        <div className="max-w-page mx-auto px-4 sm:px-6 py-6 text-[12px] text-hxd-muted flex flex-col sm:flex-row gap-2 sm:items-center sm:justify-between">
          <span>
            Hangar<span className="text-hxd-orange font-bold">X</span> Daily — Aviation &amp; AAM
            Intelligence
          </span>
        </div>
      </footer>
    </div>
  );
}
